<section
  class="container"
  *ngIf="candidate$ | async as candidate"
>
  <form
    [formGroup]="form"
    [mojoFormConnect]="candidate"
  >
    <mojo-candidate-source [form]="form"></mojo-candidate-source>
    <div class="text-center mt-3 mb-1">
      <button
        type="submit"
        color="primary"
        mat-raised-button
        class="md"
        (click)="submit(candidate.id)"
      >Save
      </button>
    </div>
  </form>
</section>
